import React from 'react';
import { Cell } from 'react-sticky-table';

import styles from './style';

const TableColumn = (props) => {
  const {
    style,
    bordered,
    sticky,
    as: asComponent,
    clickable,
    isNumber,
    children,
    singleLine,
    className,
    size = 'small',
    ...rest
  } = props || {};

  let classText = className || '';
  if (isNumber) classText += ' text-right';
  if (singleLine) classText += ' text-nowrap';
  const getStyleCol = () => {
    const styleCol = { ...styles.thead[size], ...style };
    if (clickable) return { ...styleCol, ...styles.clickable };
    if (bordered) return { ...styleCol, ...styles.border };
    return styleCol;
  };
  if (asComponent && asComponent === 'th') {
    return (
      <th className={classText} style={getStyleCol()} {...rest}>
        {children}
      </th>
    );
  }
  if (asComponent && asComponent === 'sticky') {
    return (
      <Cell className={classText} style={getStyleCol()} {...rest}>
        {children}
      </Cell>
    );
  }
  return (
    <td className={classText} style={getStyleCol()} {...rest}>
      {children}
    </td>
  );
};

export default TableColumn;
